'use client';

import { c as _c } from "react/compiler-runtime";
import type { DocumentoPadrao } from '@/features/documentosPadrao/types/documentosPadraoTypes';
import { podeExcluir, usosEmAndamento } from '@/features/documentosPadrao/utils/documentosPadraoRegras';
import { Button } from '@/shared/components/ui/common/Button';
import { IconDialog } from '@/shared/components/ui/common/IconDialog';
import { FeatherAlertTriangle, FeatherArchive, FeatherTrash2 } from '@subframe/core';
interface DocumentoPadraoExcluirDialogProps {
  aberto: boolean;
  documento: DocumentoPadrao | null;
  salvando: boolean;
  onFechar: () => void;
  onConfirmarExclusao: (documento: DocumentoPadrao) => void;
  onArquivar: (documento: DocumentoPadrao) => void;
  onVerUsos: (documento: DocumentoPadrao) => void;
}
export function DocumentoPadraoExcluirDialog(t0) {
  const $ = _c(54);
  const {
    aberto,
    documento,
    salvando,
    onFechar,
    onConfirmarExclusao,
    onArquivar,
    onVerUsos
  } = t0;
  if (!documento) {
    return null;
  }
  const bloqueado = !podeExcluir(documento);
  let t1;
  if ($[0] !== documento) {
    t1 = usosEmAndamento(documento);
    $[0] = documento;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const emAndamento = t1;
  if (bloqueado) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <FeatherAlertTriangle />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== onFechar) {
      t3 = estado => {
        if (!estado) {
          onFechar();
        }
      };
      $[3] = onFechar;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const t4 = `“${documento.nome}” está anexada a ${emAndamento} ${emAndamento === 1 ? "processo" : "processos"} em andamento. Arquive o documento: ele para de aparecer como sugestão e continua válido no que já foi protocolado.`;
    let t5;
    if ($[5] !== t4) {
      t5 = <span>{t4}</span>;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== documento || $[8] !== onVerUsos) {
      t6 = <button type="button" onClick={() => onVerUsos(documento)} className="text-caption-bold font-caption-bold text-brand-700">Ver onde está sendo usado</button>;
      $[7] = documento;
      $[8] = onVerUsos;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== t5 || $[11] !== t6) {
      t7 = <span className="flex flex-col items-start gap-2">{t5}{t6}</span>;
      $[10] = t5;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== onFechar || $[14] !== salvando) {
      t8 = <Button variant="neutral-secondary" onClick={onFechar} disabled={salvando}>Cancelar</Button>;
      $[13] = onFechar;
      $[14] = salvando;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <FeatherArchive />;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] !== documento || $[18] !== onArquivar) {
      t10 = () => onArquivar(documento);
      $[17] = documento;
      $[18] = onArquivar;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== salvando || $[21] !== t10) {
      t11 = <Button icon={t9} loading={salvando} disabled={salvando} onClick={t10}>Arquivar</Button>;
      $[20] = salvando;
      $[21] = t10;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    let t12;
    if ($[23] !== t11 || $[24] !== t8) {
      t12 = <>{t8}{t11}</>;
      $[23] = t11;
      $[24] = t8;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    let t13;
    if ($[26] !== aberto || $[27] !== onFechar || $[28] !== t12 || $[29] !== t3 || $[30] !== t7) {
      t13 = <IconDialog open={aberto} tone="warning" icon={t2} title={"N\xE3o \xE9 poss\xEDvel excluir agora"} onOpenChange={t3} onFechar={onFechar} description={t7} footer={t12} />;
      $[26] = aberto;
      $[27] = onFechar;
      $[28] = t12;
      $[29] = t3;
      $[30] = t7;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    return t13;
  }
  let t2;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherAlertTriangle />;
    $[32] = t2;
  } else {
    t2 = $[32];
  }
  let t3;
  if ($[33] !== onFechar) {
    t3 = estado_0 => {
      if (!estado_0) {
        onFechar();
      }
    };
    $[33] = onFechar;
    $[34] = t3;
  } else {
    t3 = $[34];
  }
  const t4 = `Tem certeza que deseja excluir “${documento.nome}”? O arquivo sai da biblioteca e deixa de ser sugerido. Esta ação não pode ser desfeita.`;
  let t5;
  if ($[35] !== onFechar || $[36] !== salvando) {
    t5 = <Button variant="neutral-secondary" onClick={onFechar} disabled={salvando}>Cancelar</Button>;
    $[35] = onFechar;
    $[36] = salvando;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  let t6;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherTrash2 />;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== documento || $[40] !== onConfirmarExclusao) {
    t7 = () => onConfirmarExclusao(documento);
    $[39] = documento;
    $[40] = onConfirmarExclusao;
    $[41] = t7;
  } else {
    t7 = $[41];
  }
  let t8;
  if ($[42] !== salvando || $[43] !== t7) {
    t8 = <Button variant="destructive-primary" icon={t6} loading={salvando} disabled={salvando} onClick={t7}>Excluir</Button>;
    $[42] = salvando;
    $[43] = t7;
    $[44] = t8;
  } else {
    t8 = $[44];
  }
  let t9;
  if ($[45] !== t5 || $[46] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[45] = t5;
    $[46] = t8;
    $[47] = t9;
  } else {
    t9 = $[47];
  }
  let t10;
  if ($[48] !== aberto || $[49] !== onFechar || $[50] !== t3 || $[51] !== t4 || $[52] !== t9) {
    t10 = <IconDialog open={aberto} tone="error" icon={t2} title={"Excluir documento padr\xE3o"} onOpenChange={t3} onFechar={onFechar} description={t4} footer={t9} />;
    $[48] = aberto;
    $[49] = onFechar;
    $[50] = t3;
    $[51] = t4;
    $[52] = t9;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  return t10;
}